import { __decorate } from "tslib";
import { Vue, Component, Mixins, Prop } from "vue-property-decorator";
import { uiMapper } from "@/services/store/modules/ui/store";
import { dataMapper } from "@/services/store/modules/data/store";
import IconSvg from "@/components/IconSvg.vue";
import ButtonApp from "@/components/ButtonApp.vue";
import router from "@/services/router";
const UiMappers = Vue.extend({
    computed: {
        ...uiMapper.mapState(["breakpoint"]),
    },
    methods: {
        ...uiMapper.mapMutations(["openFormCall"]),
    },
});
const DataMappers = Vue.extend({
    computed: {
        ...dataMapper.mapGetters(["formMail"]),
    },
    methods: {
        ...dataMapper.mapMutations([
            "setFormCallTitle",
            "setFormCallScreen",
            "activateFormField",
            "clearForm",
        ]),
    },
});
let ItemCatalogue = class ItemCatalogue extends Mixins(UiMappers, DataMappers) {
    get isXs() {
        return this.breakpoint === "xs";
    }
    get link() {
        return `/course/${this.item.id}`;
    }
    get formCallMail() {
        return this.formMail("callback");
    }
    async onOpenFormClick() {
        this.clearForm("callback");
        await this.$nextTick();
        this.setFormCallTitle(`Забронировать место в смене ${this.item.title}`);
        this.setFormCallScreen("Экран Какие будут смены?");
        this.activateFormField(this.formCallMail);
        this.openFormCall();
    }
    goToLink() {
        router.push(this.link);
    }
};
__decorate([
    Prop()
], ItemCatalogue.prototype, "item", void 0);
__decorate([
    Prop()
], ItemCatalogue.prototype, "index", void 0);
__decorate([
    Prop()
], ItemCatalogue.prototype, "btnType", void 0);
ItemCatalogue = __decorate([
    Component({
        components: {
            IconSvg,
            ButtonApp,
        },
    })
], ItemCatalogue);
export default ItemCatalogue;
